export default defineNuxtPlugin(() => {
  const { initAccessibility } = useAccessibility()
  initAccessibility()
})